// React Third Party Library
import { Tabs, message } from "antd";
import { useEffect, useState } from "react";
import { batch, useDispatch, useSelector } from "react-redux";

// Constant Library
import { SELECT_OPTIONS } from "../../constants/templates/billing";
import { TEMPLATE } from "../../constants";

// Components Library
import HeaderBilling from "./components/HeaderBilling";
import { TableItems } from "./components/TableBilling/item";
import { BtnSubmit, TableList } from "../../components";

// Handler Library
import { exportHDLR, tableHDLR } from "../../handlers";

// Services Library
import { TIME, REDUX as REDUX_UTIL } from "../../services/util";

// Redux Library
import * as REDUX_ACTION from "../../services/redux/actions";

// Styles Library
import styles from "../../pages/index.module.css";

const { BTN_IMG } = TEMPLATE.BTN;
const { parseExportTime } = TIME;
const { BILLING_SUMMARY_COL } = TEMPLATE.TABLEDATA.BILLING;
const { reduxStoreWrapper } = REDUX_UTIL;

const BillingList = (props) => {
  const { col } = props;
  const dispatch = useDispatch();

  const billings = useSelector(reduxStoreWrapper("billing.byID")) || {};
  const billingsCoid = useSelector(reduxStoreWrapper("billing.byCoid")) || {};
  const user = useSelector(reduxStoreWrapper("user"));
  const company = useSelector(reduxStoreWrapper("company.byID"));

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [tabKey, setTabKey] = useState("all");
  const [selectedRow, setSelectedRow] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [billing, setBilling] = useState([]);
  const [current, setCurrent] = useState(1);
  const [paginatedData, setPaginatedData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [messageApi, contextHolder] = message.useMessage();

  const statusText = {
    all: "all",
    draft: 1,
    unpaid: 2,
    pendingVerify: 3,
    paid: 4,
  };

  useEffect(() => {
    const objectValues =
      user?.uroleid === "A"
        ? Object.values(billings)
        : Object.values(billingsCoid).filter((b) => b.status !== 1);

    const updatedBilling = objectValues.map((t) => {
      const coid = t.coid?.trim();
      const cp = company[coid];
      return {
        ...t,
        key: t?.billid,
        company_name: cp?.name,
      };
    });
    setBilling(updatedBilling);
  }, [billings, company, user]);

  useEffect(() => {
    if (user.uroleid === "A") {
      batch(() => {
        dispatch(REDUX_ACTION.v1_billing.get_billing_timeframe_request());
      });
    } else {
      if (user.uroleid === "EMR") {
        batch(() => {
          dispatch(
            REDUX_ACTION.v1_billing.get_billing_timeframe_by_coid_request(
              user.coid
            )
          );
          dispatch(REDUX_ACTION.v1_company.get_all_company_request(user.coid));
        });
      }
    }
    return () => {};
  }, [dispatch, user.uroleid]);

  useEffect(() => {
    if (billing.length > 0) setFilteredData(tableHDLR.dataTableSorting(billing));
  }, [billing]);

  const handleTab = (key) => {
    setTabKey(key);
    setCurrent(1);
  };

  const filteredDataCount = tableHDLR.dataCount(statusText, filteredData);

  useEffect(() => {
    if (filteredData.length) {
      const startIndex = (current - 1) * pageSize;
      const endIndex = startIndex + pageSize;
      const newData = tableHDLR.datasourceFilter(filteredData, tabKey) ?? []
      const slicedData = newData.slice(startIndex, endIndex);
      setPaginatedData(slicedData);
    }
  }, [current, pageSize, filteredData, tabKey]);

  const handlePageChange = (page) => {
    const sorted = tableHDLR.dataTableSorting(page);
    setPaginatedData(sorted);
  };

  // Export
  const exportData = selectedRow.length > 0 ? selectedRow : filteredData
  const template = BILLING_SUMMARY_COL({
    redux: {
      user,
      billings,
      billingsCoid,
    },
    exportState: true,
  });

  const exportButton = (
    <BtnSubmit
      display="inline-block"
      text="Export"
      bgColor="transparent"
      color="#4CAF50"
      padding="9px 18px"
      onClick={() =>
        exportHDLR.exportWithTemplate({
          data: exportData,
          filename: `BillingSummary_${parseExportTime()}`,
          template: template,
        })
      }
      showIcon={true}
      icon={BTN_IMG.EXPORT}
      icon_alt={"export"}
    />
  );

  return (
    <>
      <div
        className={styles.container}
        style={{ width: col ? "80vw" : "73vw" }}
      >
        <TableList.FilterData
          isModalOpen={isModalOpen}
          setIsModalOpen={() => setIsModalOpen(false)}
          selectOptions={SELECT_OPTIONS}
          filteredData={tableHDLR.datasourceFilter(billing, tabKey)}
          setFilteredData={setFilteredData}
          tabKey={tabKey}
          statusText={statusText}
          type="billing"
        />
        <HeaderBilling
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          pageSize={pageSize}
          setPageSize={setPageSize}
          tabKey={tabKey}
          current={current}
          setCurrent={setCurrent}
          handlePaginatedChange={handlePageChange}
          filteredDataCount={filteredDataCount}
          data={filteredData}
          user={user}
          selectedRow={selectedRow}
          selectedRowKeys={selectedRowKeys}
          messageApi={messageApi}
        />
        <div style={{ marginTop: "3.5em" }}>
          <Tabs
            tabBarExtraContent={exportButton}
            onTabClick={handleTab}
            items={TableItems(
              filteredDataCount,
              billing,
              filteredData,
              paginatedData,
              tabKey,
              setFilteredData,
              selectedRow,
              setSelectedRow,
              user,
              selectedRowKeys,
              setSelectedRowKeys,
            )}
          />
        </div>
      </div>
    </>
  );
};

export default BillingList;